var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"headline white--text text-left",class:this.colorProp},[_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),_c('v-spacer'),_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }